import SignupFormContainer from './SignupFormContainer';

export default SignupFormContainer;
